export enum EntityType {
  BoardEventsInformation = 'board_eventsinformation',
  EventsInformation = 'eventsinformation',
  Incident = 'incident',
  KeyOrder = 'key_order',
  Repair = 'repair',
  Task = 'task',
}

export enum DateRangeType {
  Today = 1,
  ThisWeek,
  ThisMonth,
  ThisYear,
}

export const MAX_TODO_DESCRIPTION_LENGTH = 4000;
export const NOT_AVAILABLE_DOCUMENT_NAME_SYMBOLS = /[#%&*:<>?/{|}]/;
